<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<form #form="ngForm" (ngSubmit)="onApply()">
  <div class="modal-header">
    <div class="modal-title h5" id="modalTitle">Script Tester</div>
    <button type="button" class="close" aria-label="Close modal?" (click)="onClose()"><span aria-hidden="true">&times;</span></button>
  </div>
  <div class="modal-body row">
    <div class="col-12 col-md-6 col-xl-5">
      <div class="form-group">
        <label for="type">Type</label>
        <div class="btn-group-toggle">
          <button
            type="button"
            class="btn btn-primary d-block d-sm-inline-block"
            [class.active]="inputType === InputType.UserInput"
            (click)="inputType = InputType.UserInput"
            tabindex="0"
            data-toggle="tooltip"
            data-placement="top"
            data-original-title="Change any input parameters with fake data"
            [disabled]="isTestingScript"
          >
            User Input
          </button>
          <button
            type="button"
            class="btn btn-primary d-block d-sm-inline-block"
            [class.active]="inputType === InputType.RealData"
            (click)="inputType = InputType.RealData"
            tabindex="0"
            data-toggle="tooltip"
            data-placement="top"
            data-original-title="Change any input parameters with data from Dynamics 365"
            [disabled]="isTestingScript"
          >
            Real Data
          </button>
        </div>
      </div>
      <fieldset>
        <legend class="bold-legend">
          Input Parameters
          <i
            class="fa fa-question-circle"
            data-toggle="tooltip"
            data-placement="top"
            data-original-title="The input parameters to be used to test your script"
            title="The input parameters to be used to test your script"
            aria-hidden="true"
          ></i>
        </legend>
        <button type="button" id="resetButton" class="btn btn-danger mb-2" (click)="reset()" [disabled]="isTestingScript">
          <span class="fa fa-history mr-1" aria-hidden="true"></span> Reset to defaults
        </button>
        @if (inputType == InputType.UserInput) {
        <div class="form-group">
          <label for="createdOn-date">createdOn</label>
          <div class="input-group">
            <input
              type="date"
              class="form-control"
              id="createdOn-date"
              name="createdOn-date"
              [ngModel]="createdOnDate | date: 'yyyy-MM-dd'"
              (ngModelChange)="createdOnChanged($event)"
              [disabled]="isTestingScript"
              triggers="focus"
              placement="right"
              popoverTitle="createdOn"
              [popover]="'The date and time when the Dynamics 365 record was created (CreatedOn).'"
              aria-describedby="createdOn-time"
            />
            <div class="input-group-append">
              <input type="time" class="form-control" id="createdOn-time" name="createdOn-time" [(ngModel)]="createdOnTime" [disabled]="isTestingScript" aria-label="Created On Time" />
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="name">name</label>
          <input
            type="text"
            class="form-control"
            id="name"
            name="name"
            [(ngModel)]="name"
            [disabled]="isTestingScript"
            triggers="focus"
            placement="right"
            popoverTitle="name"
            [popover]="'The name of the Dynamics 365 record (PrimaryNameAttribute).'"
          />
        </div>
        }
        <div class="form-group">
          <label for="regardingObjectId">regardingObject.Id</label>
          <input
            type="text"
            class="form-control"
            id="regardingObjectId"
            name="regardingObjectId"
            [(ngModel)]="id"
            [disabled]="isTestingScript"
            triggers="focus"
            placement="right"
            popoverTitle="regardingObject.Id"
            [popover]="'The id of the Dynamics 365 record (Id).'"
          />
        </div>
        <div class="form-group">
          <label for="regardingObjectLogicalName">regardingObject.LogicalName</label>
          <input
            type="text"
            class="form-control"
            id="regardingObjectLogicalName"
            name="regardingObjectLogicalName"
            [(ngModel)]="logicalName"
            [readonly]="isTestingScript"
            triggers="focus"
            placement="right"
            popoverTitle="regardingObject.LogicalName"
            [popover]="'The logical name for the entity (LogicalName).'"
          />
        </div>
      </fieldset>
    </div>
    <div class="col-12 col-md-6 col-xl-7">
      <div class="form-group row">
        <label for="function" class="col-lg-2 col-md-12 col-form-label">Function</label>
        <div class="col-md-12 col-lg-6">
          <select
            class="form-control form-control-sm"
            id="function"
            name="function"
            [(ngModel)]="function"
            aria-required="true"
            aria-invalid="false"
            [disabled]="isTestingScript"
            triggers="focus"
            placement="right"
            popoverTitle="Function"
            [popover]="'The name of the function to be executed.'"
          >
            @for (option of functionOptions; track option) {
            <option [ngValue]="option.value">{{ option.label }}</option>
            }
          </select>
        </div>
      </div>

      @if (isEditorLoading) {
      <div class="editor-loading">
        <span class="fa fa-spinner fa-spin mr-1" aria-hidden="true"></span>
        The editor is being loaded. Please wait...
      </div>
      }

      <div class="editor-container mb-2">
        <ngx-monaco-editor id="script" name="script" [options]="editorOptions" [(ngModel)]="script" (init)="onMonacoInit($event)"></ngx-monaco-editor>
      </div>

      <button type="button" id="testButton" class="btn btn-success col-3" (click)="test()" [disabled]="isTestingScript">
        <span class="fa fa-play mr-1" aria-hidden="true"></span> Test @if (isTestingScript) {
        <span class="fa fa-spinner fa-spin ml-1" aria-live="polite" aria-busy="true"></span>
        }
      </button>

      <div class="output-container">
        <label for="output">Results</label>
        <div class="output" id="output">
          <pre [class.text-danger]="outputHasErrors">{{ output }}</pre>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button id="cancelButton" type="button" class="btn btn-secondary" (click)="onCancel()">Cancel</button>
    <button id="applyButton" type="submit" class="btn btn-primary">Apply and exit</button>
  </div>
</form>
